/** @todo Fix import cycle */
// eslint-disable-next-line import/no-cycle
import axios from './instance'

/**
 * WARP-567 — read-only user impersonation ("View as").
 *
 * Both endpoints return a fresh `{ access, refresh }` pair. The caller must replace its
 * stored tokens with them: the impersonation state lives in the token, so the swap is
 * what actually starts or ends the session.
 */

/**
 * Start viewing as another user.
 *
 * @param {string} userId - The user to view as.
 * @returns {Promise<object>} `{ access, refresh, impersonating, impersonator }`
 */
export const startImpersonation = async (userId) => axios.post('/impersonate/', { userId })

/**
 * Stop viewing as another user and return to your own account.
 *
 * @returns {Promise<object>} `{ access, refresh }`
 */
export const stopImpersonation = async () => axios.post('/impersonate/stop/', {})
